import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Output, QueryList, ViewChildren } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import {
  ReportCustomElements,
  ResponseIdList,
  TemplateDefinition,
  TemplateImage,
  TemplatePageSection,
  UpdateIdList
} from "../../models/report-preview/report-template";
import {
  MousePoint,
  Notifier,
  PropertyPreviewMetadata,
  ReportPreviewMetadata,
  OfflineReportPreviewService
} from "../../../_services/offline-report-preview.service";
import { SubjectModelListItem, SubjectModelWrapper } from "../../../_objects/subject-model";
import { SubjectModelService } from "../../../_services/http-api/subject-model.service";
import { ReportProperties } from "../../../_objects/report-element";
import { RoutePage } from "../../../app-routes.enum";
import { SpinnerService } from "../../../_services/spinner.service";

namespace ButtonColors {
  export const Selected = "accent";
  export const None = "primary";
}

export interface PropertyPanelDef {
  propId: string;
  title: string;
  tableData: PropertyPreviewMetadata[];
  mapTableData: Map<string, PropertyPreviewMetadata[]>;
}

@Component({
  selector: "app-report-preview-offline",
  templateUrl: "./report-preview.component.html",
  styleUrls: ["./report-preview.component.scss"],
  standalone: false
})
export class ReportPreviewOfflineComponent implements OnInit, AfterViewInit, OnDestroy {
  isReady = false;

  readonly reportContentStyle = "display: flex; flex-direction: row; background-color: dimgrey; box-sizing: border-box;";
  readonly reportPageOuterFirstStyle = "display: block; box-sizing: border-box;";
  readonly reportPageOuterStyle = "display: block; box-sizing: border-box;";

  @ViewChildren("reportPages") reportPages: QueryList<any>;
  constructor(
    public designService: OfflineReportPreviewService,
    private router: Router,
    private subjectModelService: SubjectModelService,
    private spinnerService: SpinnerService,
    private eleref: ElementRef
  ) {
    this.designService.onReady.subscribe((str) => (this.isReady = str === "ready"));
    this.notifier = {
      componentName: "report-preview.component",
      ids: { pageId: "", elementId: "" }
    };

    this.permissionForActions = {
      page: {
        add: true,
        selectAll: false
      },
      section: {
        draw: true,
        selectAll: false,
        selectByPage: false
      },
      text: {
        draw: true,
        selectAll: false,
        selectByPage: false
      },
      line: {
        draw: true,
        selectAll: false,
        selectByPage: false
      },
      image: {
        draw: true,
        selectAll: false,
        selectByPage: false
      },
      rectangle: {
        draw: true,
        selectAll: false,
        selectByPage: false
      },
      table: {
        draw: true,
        selectAll: false,
        selectByPage: false
      },
      interactiveIso: {
        draw: true,
        selectAll: false,
        selectByPage: false
      },
      summary: {
        draw: true,
        selectAll: false,
        selectByPage: false
      },
      picture: {
        draw: true,
        selectAll: false,
        selectByPage: false
      },
      dataPlate: {
        draw: true,
        selectAll: false,
        selectByPage: false
      },
      measurementPoint: {
        draw: true,
        selectAll: false,
        selectByPage: false
      },
      visualEvents: {
        draw: true,
        selectAll: false,
        selectByPage: false
      },
      signature: {
        draw: true,
        selectAll: false,
        selectByPage: false
      },
      selection: {
        delete: true
      },
      dropDownList: {
        draw: true,
        selectAll: false,
        selectByPage: false
      },
      overall: {
        undo: false,
        redo: false
      }
    };

    this.buttonColors = {
      text: ButtonColors.None,
      line: ButtonColors.None,
      image: ButtonColors.None,
      rectangle: ButtonColors.None,
      summary: ButtonColors.None,
      picture: ButtonColors.None,
      dataPlate: ButtonColors.None,
      measurementPoint: ButtonColors.None,
      visualEvents: ButtonColors.None,
      signature: ButtonColors.None,
      section: ButtonColors.None,
      table: ButtonColors.None,
      interactiveIso: ButtonColors.None,
      dropDownList: ButtonColors.None,
      customElement: ButtonColors.None
    };

    this.mySubscriber = [];
    this.mySubscriber.push(
      this.designService.onReady.subscribe((message: string) => {
        this.reportPageKeys = this.designService.getPageIds();
        this.viewCommonElement();
      })
    );
    this.mySubscriber.push(
      this.designService.onEndUpdate.subscribe((message: string) => {
        this.viewCommonElement();
      })
    );
    this.mySubscriber.push(
      this.designService.onSelectedElement.subscribe((message: string) => {
        // this.viewSelectedElement();
      })
    );
    this.mySubscriber.push(
      this.designService.onEndDraw.subscribe((message: string) => {
        // 全てのボタンの色を「選択無し」の色にする
        Object.keys(this.buttonColors).forEach((propName: string) => {
          this.buttonColors[propName] = ButtonColors.None;
        });
      })
    );

    this.loadSubjectModels();

    // this.reportType = REPORT_TYPES.find(x => x.value == this.designService.getTemplateReportType()).label;
  }

  public application = "ViSOL";

  public isVisol: boolean;

  private mySubscriber: Subscription[];
  private notifier: Notifier;
  public reportPageKeys: Array<string>;
  public buttonColors: { [buttonName: string]: string };
  public selectedPropPanels: PropertyPanelDef[];

  public selectedElements: any = [];
  public selectedPage: any;
  public isActionCut: boolean;
  private lastClickedPoint: MousePoint;

  public showSideNav: boolean;
  public subjectModelsMaster: SubjectModelWrapper[] = [];
  public subjectModelsCtrl = new FormControl<SubjectModelWrapper[]>(null);
  public commonPropPanels: PropertyPanelDef[];
  public showMenu: string;
  public readonly defaultTop: number = 200;
  public readonly errorListHeight: number = 26;
  public readonly displayErrorListNam: number = 3;
  public showAllItems: string;
  public navigatorToggle = [];
  public addElements = false;
  public preview: ReportPreviewMetadata;
  public customElementDetails: ReportCustomElements[];
  public isSelectedElementPageOnly = false;
  public reportType: string;

  public get templateName(): string {
    return this.designService.getTemplateName();
  }

  public get isSaveHtml(): boolean {
    return this.designService.isSaveHtml;
  }

  get reportPreviewStyle() {
    let str = "height: 100%; flex-grow: 1; box-sizing: border-box;";
    if (!this.isSaveHtml) {
      str += " padding: 8px;";
    }

    return str;
  }

  public permissionForActions: {
    [objectName: string]: {
      [actionName: string]: boolean;
    };
  };

  @Output() public closeSnackBar = new EventEmitter<any>();
  @Output() public pageRendered = new EventEmitter<boolean>();

  public ngOnInit() {
    this.isVisol = true;
  }

  public ngAfterViewInit(): void {
    this.reportPages.changes.subscribe((_) => {
      setTimeout(() => {
        this.pageRendered.emit(true);
      }, 2000);
    });
  }

  public ngOnDestroy() {
    this.mySubscriber.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  public scrollEvent(eve) {
    const pageNo = Math.floor(eve.target.scrollTop / (this.designService.getPaperHeightPx() + 8)); // ページ間隔8pxを足す
  }

  public onClick() {
    // レポート要素のonClickイベント内で、event.stopPropagation()を実行しているので
    // レポート要素Click時はこの処理が動かない。
    // レポート要素以外の部分をクリックしたら、すべてのレポート要素の選択状態を解除する。
    this.selectedPropPanels = [];
  }

  public selectElement(element, event) {
    this.showAllItems = "";

    const notifier = {
      componentName: "report-preview.component",
      ids: { pageId: element.page, elementId: element.id }
    };
    const dom: HTMLElement = this.eleref.nativeElement; // Code for autoscroll
    const elements = dom.querySelector("#pageScroll");
    elements.scroll(0, this.designService.getPaperHeightPx() * this.designService.getPageIds().indexOf(element.page));
  }
  public getUsedFileNameList(): string[] {
    const usedFileNameList = [];
    const originTemplate: TemplateDefinition = this.designService.getOriginTemplate().template;
    const editingTemplate: TemplateDefinition = this.designService.getTemplate();

    originTemplate.header.images.forEach((image: TemplateImage) => {
      usedFileNameList.push(image.src.split("/").pop());
    });
    originTemplate.bodies.forEach((page: TemplatePageSection) => {
      page.images.forEach((image: TemplateImage) => {
        if (image.src) {
          usedFileNameList.push(image.src.split("/").pop());
        }
      });
    });
    originTemplate.footer.images.forEach((image: TemplateImage) => {
      usedFileNameList.push(image.src.split("/").pop());
    });
    editingTemplate.header.images.forEach((image: TemplateImage) => {
      usedFileNameList.push(image.src.split("/").pop());
    });
    editingTemplate.bodies.forEach((page: TemplatePageSection) => {
      page.images.forEach((image: TemplateImage) => {
        if (image.src) {
          usedFileNameList.push(image.src.split("/").pop());
        }
      });
    });
    editingTemplate.footer.images.forEach((image: TemplateImage) => {
      usedFileNameList.push(image.src.split("/").pop());
    });
    return Array.from(new Set(usedFileNameList));
  }
  public isModelSelectedNone(): boolean {
    if (!this.reportPageKeys) {
      return false;
    } else {
      return (
        this.reportPageKeys.length === 0 ||
        !this.designService.getTemplateSubjectModelIds() ||
        this.designService.getTemplateSubjectModelIds().length === 0
      );
    }
  }
  public cancel() {
    this.router.navigate([RoutePage.IndexPage]);
  }

  @HostListener("window:keydown", ["$event"])
  public onKeyPress($event: any) {
    if ($event.target.tagName === "INPUT" || $event.target.tagName === "TEXTAREA") {
      return;
    }

    if (($event.ctrlKey || $event.metaKey) && $event.keyCode === 67) {
      this.copySelectedElements();
    }

    if (($event.ctrlKey || $event.metaKey) && $event.keyCode === 88) {
      this.cutSelectedElements();
    }
  }
  @HostListener("mousemove", ["$event"])
  public handleMousemove(event) {
    this.lastClickedPoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };
  }

  public onMouseDown($event: MouseEvent) {
    const selectedElements: any = this.designService.getSelectedElementProperties();

    this.selectedPage = selectedElements.find((el) => el.type.toLowerCase() === "page");
  }

  public cutSelectedElements(): void {
    this.isActionCut = true;
    this.copySelectedElements();
  }

  public copySelectedElements(): void {
    const selectedElements: any = this.designService.getSelectedElementProperties();
    this.selectedElements = selectedElements.filter((el) => el.type.toLowerCase() !== "page");
    this.selectedPage = selectedElements.find((el) => el.type.toLowerCase() === "page");
  }

  public getSortedSubjectModels(): SubjectModelWrapper[] {
    return this.subjectModelsCtrl.value.slice().sort((a, b) => a.order - b.order);
  }

  public loadSubjectModels(): void {
    let subjectModels: SubjectModelListItem[];
    this.subjectModelService.getSubjectModels().subscribe(
      (sb) => {
        subjectModels = sb;
      },
      (error) => {
        console.log(error);
      },
      () => {
        this.subjectModelsMaster = subjectModels.map((item) => new SubjectModelWrapper(item));
        this.designService.getTargetIdList().subscribe(
          (Idl) => {
            this.subjectModelsCtrl.setValue(this.initSubjectModels(this.subjectModelsMaster, Idl));
          },
          (error) => {
            console.log(error);
          },
          () => {}
        );
      }
    );
  }

  public changeTargetSubjectModels() {
    this.spinnerService.show();
    let updateIdList: UpdateIdList = new UpdateIdList();
    updateIdList = this.updateSubjectModelTemplate(this.subjectModelsCtrl.value, updateIdList);
    this.closeSnackBar.emit({ isDestory: false, setTime: 3000000 });
  }

  public initSubjectModels(masters: SubjectModelWrapper[], selection: ResponseIdList[]): SubjectModelWrapper[] {
    if (!masters || !selection) {
      return [];
    }
    const ids: string[] = selection.map((targetIdList) => targetIdList.subjectModelId);
    const selected: SubjectModelWrapper[] = [];
    ids.forEach((id, index) => {
      masters.forEach((master) => {
        if (id === master.subjectModel.id) {
          selected.push(master);
          master.order = index;
        }
      });
    });
    return selected;
  }

  public updateSubjectModelTemplate(subjectModelValue: SubjectModelWrapper[], updateIdList: UpdateIdList): UpdateIdList {
    updateIdList.subjectModelIds = subjectModelValue.map((wrapper) => wrapper.subjectModel.id);
    return updateIdList;
  }

  public viewCommonElement() {
    const commProps: ReportProperties[] = this.designService.getCommonProperties();
    this.commonPropPanels = [];
    commProps.forEach((reportProperties: ReportProperties) => {
      this.commonPropPanels.push({
        propId: reportProperties.getId(),
        title: reportProperties.getTitle(),
        tableData: reportProperties.getProperties(),
        mapTableData: reportProperties.getMapProperties()
      });
    });
  }
}
